import React, { useEffect, useState } from "react";
import { Row, Col, Card, Spinner } from "react-bootstrap";
import Table from "../../components/Table";
import { withSwal } from "react-sweetalert2";
import PageTitle from "../../components/PageTitle";
import { getData } from "../../helpers/api/userReferals";

const BasicInputElements = withSwal((props: any) => {
  const { state, initialLoading } = props;
  const [loading, setLoading] = useState<boolean>(false);

  const records = state || [];

  const columns = [
    {
      Header: "Sl No",
      accessor: "",
      Cell: ({ row }: any) => <>{row.index + 1}</>,
      sort: false,
    },
    {
      Header: "Code",
      accessor: "code.code",
      sort: true,
    },
    {
      Header: "User",
      accessor: "user.name",
      sort: true,
    },
  ];

  if (initialLoading || loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "60vh" }}>
        <Spinner animation="border" />
      </div>
    );
  }

  return (
    <Row className="justify-content-between px-2">
      <Col className="p-0 form__card">
        <Card className="bg-white">
          <Card.Body>
            <Table
              columns={columns}
              data={records}
              pageSize={300}
              isSortable={true}
              pagination={true}
              isSearchable={true}
              theadClass="table-light mt-2"
              searchBoxClass="mt-2 mb-3"
            />
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
});

const ReferalUses = () => {
  const [state, setState] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [initialLoading, setInitialLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchReferals = async () => {
      try {
        setLoading(true);
        const response = await getData();
        setState(response.data?.data || []);
      } catch (err: any) {
        console.error("Error fetching referral data:", err);
        setError("Failed to load referral data");
      } finally {
        setLoading(false);
        setInitialLoading(false);
      }
    };

    fetchReferals();
  }, []);

  return (
    <React.Fragment>
      <PageTitle
        breadCrumbItems={[
          { label: "Master", path: "", active: true },
          { label: "Users", path: "", active: true },
        ]}
        title={"Referral Usage"}
      />

      <Row>
        <Col>
          <BasicInputElements state={state} loading={loading} error={error} initialLoading={initialLoading} />
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default ReferalUses;
